import { Node_Type } from "./../../ricos-types/index.js";
import Html from "./html.js";
const nodeViewRenderers = {
  [Node_Type.HTML]: Html
};
export {
  nodeViewRenderers
};
//# sourceMappingURL=node-view-renderers.js.map
